export default function stringToArray(value: string): string[] {
  const values = value.split(',').filter(val => val);
  return values.reduce((result: string[], element: string) => {
    if (
      result.every(
        (el: string) => el.toLowerCase() !== element.toLowerCase().trim()
      )
    ) {
      result.push(element.trim());
    }
    return result;
  }, []);
}
